export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20a%20modern%20bright%20logistics%20center%20with%20organized%20shelving%20rows%20and%20natural%20skylight%20illumination%2C%20neatly%20stacked%20parcels%20in%20various%20sizes%20on%20clean%20industrial%20shelves%2C%20warm%20natural%20light%2C%20efficient%20organized%20workspace%20with%20workers%20in%20the%20distance%2C%20modern%20industrial%20aesthetic%2C%20clean%20pale%20walls%2C%20no%20text%20or%20logos%2C%20bright%20productive%20atmosphere&width=1800&height=800&seq=cta-v2-panoramic&orientation=landscape"
          alt="AllChinaBuy Spreadsheet sourcing"
          title="AllChinaBuy Spreadsheet – Start Sourcing Today"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              Start Using AllChinaBuy Spreadsheet Today
            </h2>
            <p className="text-white/80 text-lg leading-relaxed">
              Join thousands of dropshippers and resellers who trust our verified supplier database for their China sourcing needs.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white text-foreground-950 font-semibold text-base rounded-full hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>Open Live Spreadsheet</span>
              <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}